import { takeLatest, put, call } from 'redux-saga/effects';
import { AvailableTimeMap, CoachAction, CoachTypes } from '../types';
import { coachError, getListCoach, updateCoachAvailableTime } from '../actions';
import { addCoachInfoFirebase, updateCoachAvailableTimeFirebase, getCoachListFirebase } from '../repository';
import strings from '../../../resources/strings';

export function* requestAddCoachInfoSaga(
    props: CoachAction<{ description: Record<string, string>; image: string; phoneNumber: string; uid: string }>,
): unknown {
    try {
        const uid = props.payload.uid;
        const description = props.payload.description;
        const image = props.payload.image;
        const phoneNumber = props.payload.phoneNumber;
        yield call(addCoachInfoFirebase, description, image, phoneNumber, uid);
    } catch (err: unknown) {
        yield put(coachError(`${strings.coachPage.errors.addCoachInfo}, error: ${err}`));
    }
}

export function* requestGetListCoachSaga(): unknown {
    try {
        const coachData = yield call(getCoachListFirebase);
        yield put(getListCoach(coachData));
    } catch (err: unknown) {
        yield put(coachError(`${strings.coachPage.errors.getCoach}, error: ${err}`));
    }
}

export function* requestUpdateCoachAvailableTimeSaga(
    props: CoachAction<{ availableTimeMap: AvailableTimeMap; coachId: string }>,
): unknown {
    try {
        const coachId = props.payload.coachId;
        const availableTimeMap = props.payload.availableTimeMap;
        const coachAvailableTime = yield call(updateCoachAvailableTimeFirebase, coachId, availableTimeMap);
        yield put(updateCoachAvailableTime(coachId, coachAvailableTime));
    } catch (err: unknown) {
        yield put(coachError(`${strings.coachPage.errors.updateAvailableTimeCoach}, error: ${err}`));
    }
}

export default [
    takeLatest(CoachTypes.ADD_COACH_INFO, requestAddCoachInfoSaga),
    takeLatest(CoachTypes.REQUEST_GET_LIST_COACH, requestGetListCoachSaga),
    takeLatest(CoachTypes.REQUEST_UPDATE_COACH_AVAILABLE_TIME, requestUpdateCoachAvailableTimeSaga),
];
